import type { Obstacle } from "./level";

/** Live-enemy snapshot consumed by player weapon collision. */
export interface EnemyHitData {
  xx: number;
  yy: number;
  dead: boolean;
  hitRadius: number;
}

/** Tests each movement axis with the other axis left at its current position. */
export function blockMovementAxes(
  currentX: number,
  currentY: number,
  futureX: number,
  futureY: number,
  radius: number,
  levelWidth: number,
  levelHeight: number,
  obstacleBuckets: readonly (readonly Obstacle[])[],
  barriers: readonly Obstacle[],
  out: [boolean, boolean],
): [boolean, boolean] {
  out[0] = true;
  out[1] = true;
  if (futureY - radius < 0) {
    out[1] = false;
  }
  if (futureY + radius > levelHeight) {
    out[1] = false;
  }
  if (futureX - radius < 0) {
    out[0] = false;
  }
  if (futureX + radius > levelWidth) {
    out[0] = false;
  }
  for (
    let bucketIndex = 0;
    bucketIndex < obstacleBuckets.length;
    bucketIndex++
  ) {
    const bucket = obstacleBuckets[bucketIndex];
    for (
      let obstacleIndex = 0;
      obstacleIndex < bucket.length;
      obstacleIndex++
    ) {
      const obstacle = bucket[obstacleIndex];
      if (
        currentY + radius > obstacle.y1 &&
        currentY - radius < obstacle.y2 &&
        futureX + radius > obstacle.x1 &&
        futureX - radius < obstacle.x2
      ) {
        out[0] = false;
      }
      if (
        futureY + radius > obstacle.y1 &&
        futureY - radius < obstacle.y2 &&
        currentX + radius > obstacle.x1 &&
        currentX - radius < obstacle.x2
      ) {
        out[1] = false;
      }
    }
  }
  for (let barrierIndex = 0; barrierIndex < barriers.length; barrierIndex++) {
    const barrier = barriers[barrierIndex];
    if (
      currentY + radius > barrier.y1 &&
      currentY - radius < barrier.y2 &&
      futureX + radius > barrier.x1 &&
      futureX - radius < barrier.x2
    ) {
      out[0] = false;
    }
    if (
      futureY + radius > barrier.y1 &&
      futureY - radius < barrier.y2 &&
      currentX + radius > barrier.x1 &&
      currentX - radius < barrier.x2
    ) {
      out[1] = false;
    }
  }
  return out;
}
